module.exports = __webpack_public_path__ + "static/media/zhichi.50bc02a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageUrlSec/zhichi.svg
// module id = 571
// module chunks = 0